import { Copy, Download, MapPin } from "lucide-react";
import VoiceCard from "@/components/VoiceCard";
import ShareButtons from "@/components/ShareButtons";

export default function CardModal({ open, onClose, cardRef, pledge, shareText, championUrl, cardUrl, getImage, onDownload, onCopyMessage, onCopyLink, busy }) {
  return (
    <div className={`modal-overlay ${open ? "open" : ""}`} onClick={(e) => e.target.classList.contains("modal-overlay") && onClose()}>
      <div className="modal-box">
        <div className="modal-title">Your Voice Card 🗳️</div>
        <div className="modal-sub">Download it and share everywhere!</div>
        <VoiceCard ref={cardRef} {...pledge} />
        <ShareButtons text={shareText} url={championUrl} getImage={getImage} name={pledge.name} />
        {championUrl && (
          <div className="link-box" style={{ marginTop: 16 }}>
            <code>{championUrl}</code>
            <button className="link-copy-btn" onClick={onCopyLink}><Copy size={13} /></button>
          </div>
        )}
        <div className="modal-actions">
          <button className="btn-yellow" onClick={onDownload} disabled={busy} data-testid="download-card-btn">
            <Download size={16} style={{ marginRight: 6, verticalAlign: "-3px" }} />{busy ? "Generating…" : "Download My Card"}
          </button>
          <button className="btn-primary" onClick={onCopyMessage} style={{ width: "100%", fontSize: 14, padding: "12px 26px", boxShadow: "none" }} data-testid="copy-message-btn">
            <Copy size={15} style={{ marginRight: 6, verticalAlign: "-3px" }} />Copy Message Text
          </button>
          {cardUrl && (
            <a className="vc-toolbox" href={cardUrl} target="_blank" rel="noopener noreferrer" style={{ color: "var(--dream-aqua)", fontSize: 12 }} data-testid="hosted-card-link">
              <MapPin size={11} style={{ verticalAlign: "-1px" }} /> Open hosted image link
            </a>
          )}
          <button className="btn-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
